module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "privacy-policy-text",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPrivacyPolicyText(_vm.privacyPolicyText))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4be9bbf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Rgpd.vue
// module id = 2104
// module chunks = 2